import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { useTranslation } from 'react-i18next';
import jaLocale from 'date-fns/locale/ja';
import enLocale from 'date-fns/locale/en-US';
import format from 'date-fns/format';

interface Props {
  date: Date;
  onSelectedDateChange: (date: Date | null) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    datePicker: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
    },
  })
);

export default ((props) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const getLocale = () => {
    switch (i18n.language) {
      case 'ja':
        return jaLocale;
      default:
        return enLocale;
    }
  };

  const formatDate = (date: Date, locale: Locale): string => {
    const formatString = locale === jaLocale ? 'yyyy年M月d日' : 'yyyy/MM/dd';
    return format(date, formatString, { locale });
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={getLocale()}>
      <KeyboardDatePicker
        className={classes.datePicker}
        label={t("recordedDate")}
        format="yyyy/MM/dd"
        value={props.date}
        onChange={props.onSelectedDateChange}
        KeyboardButtonProps={{
          'aria-label': t("changeDate"),
        }}
        okLabel={t("ok")}
        cancelLabel={t("cancel")}
        invalidDateMessage={t("invalidDate")}
        minDateMessage={t("minDate")}
        maxDateMessage={t("maxDate")}
        labelFunc={(date) => formatDate(date ?? new Date(), getLocale())}
      />
    </MuiPickersUtilsProvider>
  );
}) as React.FC<Props>;